import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=4cdf7a28"
import script from "./BookingCard.vue?vue&type=script&lang=js"
export * from "./BookingCard.vue?vue&type=script&lang=js"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=4cdf7a28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports